// SKU search on the search results page.
// - Full SKU (CTP14599)  -> search tag:"x-styleCode:CTP14599"
// - Digits only (14599)  -> regex finds every style code = 3 letters + 14599 among the store's tags,
//                           then searches those exact tags joined with OR
// - Missing letters (SN2946, N2946) -> same, the code is 3 letters in total
// - On the results page the tag syntax is hidden again: the page shows what the user typed.
(function () {
  var SKU_RE = /^[A-Za-z]{3,6}\d{3,}(-\d+)?$/;   // CTP14599, NNP30697, CSL3608-1 ... (full code)
  var PART_RE = /^([A-Za-z]{1,2})\d{3,}(-\d+)?$/; // SN2946, N2946 (first letters missing)
  var NUM_RE = /^\d{3,}(-\d+)?$/;                 // 14599
  var CODE_LETTERS = 3;                              // style codes start with 3 letters
  var TAGS_RE = /tag:\s*["\u201C]x-styleCode:[^"\u201D]+["\u201D](?:\s+OR\s+tag:\s*["\u201C]x-styleCode:[^"\u201D]+["\u201D])*/gi;
  var CACHE_KEY = 'skuCodesV1';
  var TTL = 6 * 60 * 60 * 1000;                   // style code list cached for 6 hours

  if (!/\/search\/?$/.test(window.location.pathname)) return;

  var params = new URLSearchParams(window.location.search);
  var q = (params.get('q') || '').trim();

  function go(skus, typed) {
    var expr = skus.map(function (s) { return 'tag:"x-styleCode:' + s + '"'; }).join(' OR ');
    try { sessionStorage.setItem('skuTyped:' + expr, typed); } catch (e) {}
    params.set('q', expr);
    window.location.replace(window.location.pathname + '?' + params.toString());
  }

  // All style codes in the store, read once from the product tags
  function loadCodes() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c.d);
    } catch (e) {}

    var codes = {};
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var list = data.products || [];
          list.forEach(function (p) {
            var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
            tags.forEach(function (t) {
              var m = String(t).trim().match(/^x-styleCode:\s*(.+)$/i);
              if (m) codes[m[1].trim().toUpperCase()] = m[1].trim();
            });
          });
          return list.length === 250 && n < 40 ? page(n + 1) : null;
        });
    }
    return page(1).then(function () {
      var d = Object.keys(codes).map(function (k) { return codes[k]; });
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
  }

  // 1) Full SKU typed
  if (SKU_RE.test(q)) { go([q], q); return; }

  // 2) Digits only, or first letters missing: find the real codes with a regex
  var partial = q.match(PART_RE);
  if (NUM_RE.test(q) || partial) {
    var missing = partial ? '{0,' + (CODE_LETTERS - partial[1].length) + '}' : '{' + CODE_LETTERS + '}';
    var re = new RegExp('^[A-Za-z]' + missing + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i');
    loadCodes().then(function (codes) {
      var hits = codes.filter(function (c) { return re.test(c); }).slice(0, 20);
      if (hits.length) go(hits, q);       // no hits -> normal Shopify search stays
    }).catch(function () {});
    return;
  }

  // 3) Already a rewritten query: show the typed text instead of the tag syntax
  if (!/^tag:\s*"x-styleCode:/i.test(q)) return;

  var typed = null;
  try { typed = sessionStorage.getItem('skuTyped:' + q); } catch (e) {}
  if (!typed) {                            // opened via a direct link: derive from the tags
    var skus = [];
    q.replace(/x-styleCode:([^"]+)"/gi, function (m, s) { skus.push(s); return m; });
    var nums = skus.map(function (s) { return s.replace(/^[A-Za-z]+/, ''); });
    typed = skus.length === 1 ? skus[0]
      : nums.every(function (n) { return n === nums[0]; }) ? nums[0] : skus.join(', ');
  }

  function clean(s) { return s.replace(TAGS_RE, function () { return typed; }); }

  function fix() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var tag = node.parentNode && node.parentNode.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') continue;
      var text = clean(node.nodeValue);
      if (text !== node.nodeValue) node.nodeValue = text;
    }
    Array.prototype.forEach.call(document.querySelectorAll('input'), function (input) {
      if (input.type === 'hidden') return;
      var value = clean(input.value || '');
      if (value !== input.value) input.value = value;
    });
    var title = clean(document.title);
    if (title !== document.title) document.title = title;
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(fix, 50); }

  function init() {
    fix();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();